export default __webpack_public_path__ + "static/1240-1c6d8a2878f64f43a96e809f068cb403.gif";